import { Dropdown, Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import type { MeetingsQuickSwitcherData } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { CardTitle } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { DROPDOWN_HEIGHT_ADJUST } from '@swf/sports/utils/constants';

import Meeting from '../../components/MeetingSwitcher/components/Meeting/Meeting';
import NextOff from '../../components/MeetingSwitcher/components/NextOff/NextOff';

import { TXTWCL_International, TXTWCL_UK_X_Ireland } from './Meetings.messages.json';
import styles from './Meetings.scss';

const headerMap = {
  ISP_I18N_UK_X_IRELAND: TXTWCL_UK_X_Ireland,
  ISP_I18N_INTERNATIONAL: TXTWCL_International
};

interface MeetingProps {
  title: React.ReactNode;
  quickSwitcherData: MeetingsQuickSwitcherData;
}
const Meetings: React.FC<MeetingProps> = ({ title, quickSwitcherData }) => {
  const dropdownTitle = (
    <>
      <FormattedDateTime
        date={quickSwitcherData.races[quickSwitcherData.firstOffRaceId].startTime}
        format="long"
        hideTime
      />{' '}
      - <Translation {...headerMap[quickSwitcherData.header]} />
    </>
  );

  return quickSwitcherData.groups.length > 1 ? (
    <Dropdown
      title={dropdownTitle}
      verticalOffset="XXS"
      triggerEl={({ arrowRef, ...props }) => (
        <CardTitle {...props} isDropdown>
          {title}
          <Icon ref={arrowRef} icon={ChevronMediumDown} size="sm" className={styles.icon} />
        </CardTitle>
      )}
      overlay
      overrideHeightAdjust={DROPDOWN_HEIGHT_ADJUST}
    >
      <NextOff />
      {quickSwitcherData.groups.map((raceIds) => (
        <Meeting key={raceIds[0]} raceIds={raceIds} />
      ))}
    </Dropdown>
  ) : (
    <CardTitle>{title}</CardTitle>
  );
};

export default Meetings;
